import { render } from "./Init.vue?vue&type=template&id=205f6f14&scoped=true"
import script from "./Init.vue?vue&type=script&lang=js"
export * from "./Init.vue?vue&type=script&lang=js"

import "./Init.vue?vue&type=style&index=0&id=205f6f14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205f6f14"]])

export default __exports__